import { fetcher } from '@commenda/utils';

export async function deleteRegistration(businessEntityId: number, id: string) {
  const response = await fetcher(
    `business-entities/${businessEntityId}/registrations/${id}`,
    {
      method: 'DELETE',
    }
  );

  return response;
}
